export class ServiceClass {
  public numServiceClassId: number;
  public strServiceClassCode = '';
  public strServiceClass = '';
  public numRegionId: number;
  public ysnDemandBasedService: any;
  public strServiceClassCodeName = '';
}
